import { ThemeEvents, VariantUpdateEvent } from '@theme/events';

class ProductPrice extends HTMLElement {
  #closestSection = null;

  connectedCallback() {
    this.#closestSection = this.closest('.shopify-section');
    this.#closestSection?.addEventListener(ThemeEvents.variantUpdate, this.#updatePrice);
  }

  disconnectedCallback() {
    this.#closestSection?.removeEventListener(ThemeEvents.variantUpdate, this.#updatePrice);
    this.#closestSection = null;
  }

  get #productId() {
    return this.getAttribute('data-product-id');
  }

  /**
   * Updates the price element with new HTML from the variant update event.
   * @param {VariantUpdateEvent} event - The variant update event.
   */
  #updatePrice = (event) => {
    const target = event.target;

    if (target instanceof HTMLElement && target.getAttribute('data-product-id') !== this.#productId) {
      return;
    }

    const { html } = event.detail.data;

    const currentPriceElement = this.querySelector('[data-ref="priceContainer"]');
    const newPriceElement = html.querySelector('product-price [data-ref="priceContainer"]');

    if (!currentPriceElement || !newPriceElement) return;

    if (currentPriceElement.innerHTML !== newPriceElement.innerHTML) {
      currentPriceElement.innerHTML = newPriceElement.innerHTML;
    }
  };
}

if (!customElements.get('product-price')) {
  customElements.define('product-price', ProductPrice);
}
